/**
 * Process post data and output as media object.
 * @param  {Object} data The post data from the post factory api.
 * @return {string}      the html markup.
 */
export const filterableContentTemplate = (data) => {
	// Get Conditional elements.
	let {
		image,
		label,
		meta,
		excerpt,
	} = data;

	// Static Elements.
	const {
		id,
		link,
		title,
		extraMeta,
		isFeatured,
		color,
	} = data;

	/**
	 * Output links based on post data.
	 * @param  {object}  link      the post link object.
	 * @param  {string}  content   The link content.
	 * @param  {string}  className the link classes.
	 */
	const linkRender = (link, content, className = false) => {
		const rel = link.target === '_blank' ? 'rel="noopener norefferer"' : '';
		className = className ? `class="${className}"` : '';
		return `<a ${className} data-id="${id}" href="${link.url}" target="${link.target}" ${rel}>${content}</a>`;
	};

	// If Image then display image markup.
	if (image && !extraMeta) {
		image = `
			<div class="media-object__media">
				${linkRender(data.link, `<img class="object-fit--cover" alt="${image.alt}" src="${image.src}" />`)}
			</div>`;
	}

	// If label then display label markup.
	if (label) {
		label = `<div class="media-object__label">${label}</div>`;
	}

	// If meta data then display meta markup.
	if (meta && meta.length > 0) {
		let metaRender = '<ul class="media-object__meta meta">';

		meta.forEach((m) => {
			metaRender += `<li>${m}</li>`;
		});

		metaRender += '</ul>';

		meta = metaRender;
	}

	// If excerpt then display excerpt markup.
	if (excerpt) {
		excerpt = `<div class="media-object__excerpt">${excerpt}</div>`;
	}

	function formatExtraMeta(extraMeta) {
		let output = '';

		extraMeta.forEach((meta) => {
			const categories = [];
			let metaItems = '';

			if (typeof meta.data === 'object') {
				const dataObj = meta.data;

				dataObj.forEach((obj) => {
					categories.push(obj.name);
				});

				metaItems = categories.join(', ');
			} else {
				metaItems = meta.data;
			}

			if (metaItems) {
				output += `
					<div class="media-object__extra-meta-item">
						<div class="label">${meta.title}</div>
						<div class="list">${metaItems}</div>
					</div>
				`;
			}
		});

		return output;
	}

	let extraMetaOutput = '';
	if (extraMeta) {
		extraMetaOutput = `
			<div class="media-object__extra-meta">
				${formatExtraMeta(extraMeta)}
			</div>
		`;
	}

	const featuredIcon = `
		<span class="featured-icon">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M381.2 150.3L524.9 171.5C536.8 173.2 546.8 181.6 550.6 193.1C554.4 204.7 551.3 217.3 542.7 225.9L438.5 328.1L463.1 474.7C465.1 486.7 460.2 498.9 450.2 506C440.3 513.1 427.2 514 416.5 508.3L288.1 439.8L159.8 508.3C149 514 135.9 513.1 126 506C116.1 498.9 111.1 486.7 113.2 474.7L137.8 328.1L33.58 225.9C24.97 217.3 21.91 204.7 25.69 193.1C29.46 181.6 39.43 173.2 51.42 171.5L195 150.3L259.4 17.97C264.7 6.954 275.9-.0391 288.1-.0391C300.4-.0391 311.6 6.954 316.9 17.97L381.2 150.3z"/></svg>
		</span>
	`;

	let mediaFooter = '';
	const mediaSidebar = '';

	mediaFooter = `
		<div class="media-object__footer">
			<span class="favorite-post-toggle" data-id="${id}">
				<svg viewBox="0 0 27.058 25.505" xmlns="http://www.w3.org/2000/svg"><path d="M13.53 24.505q-.364 0-.616-.276l-8.726-9.212q-.14-.122-.384-.398-.245-.275-.776-1.002-.532-.727-.951-1.492-.42-.765-.748-1.852Q1 9.187 1 8.162q0-3.367 1.776-5.264Q4.552 1 7.684 1q.867 0 1.769.329.902.329 1.678.888.776.558 1.335 1.048.56.49 1.063 1.04.504-.55 1.063-1.04.56-.49 1.335-1.048.776-.559 1.678-.888Q18.507 1 19.375 1q3.131 0 4.907 1.898 1.776 1.897 1.776 5.264 0 3.382-3.202 6.886l-8.712 9.181q-.251.276-.615.276z" fill="#fff" stroke="#000" stroke-width="2"/></svg>
			</span>
			${isFeatured ? featuredIcon : ''}
		</div>
	`;

	const colorClass = color ? `is-featured has-${color}-border-color has-opaque-${color}-background` : '';

	// The media object.
	const html = `
		<div class="em-col">
			<div class="media-object ${colorClass}">
				${image}

				<div class="media-object__body">
					${label}

					<h3 class="media-object__headline h4" itemprop="headline">
						${linkRender(link, title)}
					</h3>

					${meta}

					${excerpt}

					${mediaFooter}
				</div>

				${mediaSidebar}

				${extraMetaOutput}
			</div>
		</div>
	`;

	return html;
};

export const noResultsTemplate = (data) => `<div class="em-col"><p class="no-results">${data}</p></div>`;
